import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import CurrencySwitch from '../../../../../../gqlCommon/components/currencySwitch/CurrencySwitch';
import locale from '../../../../../../common/service/locale';
import { usePersistedCurrencyPreference } from '../../../../../hooks/currency/usePersistedCurrencyPreference';
import usePrice from '../../../../../../gqlCommon/hooks/prices/usePrice';
import usePriceValidation from '../../../../../../gqlCommon/hooks/currency/usePriceValidation';
import useCustomizeCarContext from '../../../../../hooks/useCustomizeCarContext';

const CurrencySwitchContainer: FC = () => {
  const { selectedCar } = useCustomizeCarContext();
  const prices = selectedCar?.prices.carPrice.originalPrice;
  const { primaryPrice, secondaryPrice } = usePrice(selectedCar?.prices.carPrice.originalPrice);
  const { isMultiCurrency } = usePriceValidation(prices);
  const primaryCurrency = primaryPrice.money.currency;
  const secondaryCurrency = secondaryPrice.money.currency;
  const { isSecondaryCurrencyDisplay, setIsSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();

  return (
    <Grid item={true}>
      {isMultiCurrency && (
        <CurrencySwitch
          name="currency-switch"
          data-test="summary:currency-toggle"
          disableRipple={false}
          labelBefore={locale.getCurrencyLocaleCodeForLabel(primaryCurrency)}
          labelAfter={locale.getCurrencyLocaleCodeForLabel(secondaryCurrency)}
          checked={isSecondaryCurrencyDisplay}
          onChange={setIsSecondaryCurrencyDisplay}
        />
      )}
    </Grid>
  );
};

export default CurrencySwitchContainer;
